import * as actionTypes from './actionTypes';

export const addNewDenomination = (denominations) => {
  return {
    type: actionTypes.ADD_NEW_DENOMINATION,
    payload: denominations,
  };
};

export const removeAnDenomination = (AMOUNT) => {
  return {
    type: actionTypes.REMOVE_AN_DENOMINATION,
    payload: { AMOUNT },
  };
};

export const quantityIncrementDenomination = (AMOUNT, QUANTITY, rangeDenomination) => {
  return {
    type: actionTypes.UPDATE_QUANTITY_DENOMINATION,
    payload: { AMOUNT, QUANTITY, rangeDenomination },
  };
};

export const quantityDecrementDenomination = (AMOUNT, QUANTITY) => {
  return {
    type: actionTypes.UPDATE_QUANTITY_DENOMINATION,
    payload: { AMOUNT, QUANTITY },
  };
};

export const setNewDenomination = (denominations) => {
  return {
    type: actionTypes.SET_NEW_DENOMINATION,
    payload: denominations,
  };
};

export const wipeOutDenomination = () => {
  return {
    type: actionTypes.WIPE_OUT_DENOMINATION,
  };
};

export const setCouponData = (couponData) => {
  return {
    type: actionTypes.SET_COUPON_DATA,
    payload: couponData,
  };
};

export const couponStatusUpdate = (couponData) => {
  return {
    type: actionTypes.COUPOUN_STATUS_UPDATE,
    payload: couponData,
  };
};

export const couponInputHandlerData = (couponData) => {
  return {
    type: actionTypes.COUPOUN_CODE_INPUT,
    payload: couponData,
  };
};

export const couponAppliedReset = () => {
  return {
    type: actionTypes.COUPOUN_APPLIED_RESET,
  };
};

export const couponCodeClear = () => {
  return {
    type: actionTypes.COUPOUN_CLEAR,
  };
};
